/* eslint-disable no-new */
/**
 THRU  - Admin Dashboard
 @page Components Index
 @description Index for pages router
*/

import Vue from 'vue';
import Router from 'vue-router';

//DASHBOARD PAGES
import Login from '@/router/Customer/Login.vue';
import TopPage from '@/router/Customer/TopPage.vue';
import BankStatus from '@/router/Customer/BankStatus.vue';
import RackStatus from '@/router/Customer/RackStatus.vue';
import PackStatus from '@/router/Customer/PackStatus.vue';
import CellStatus from '@/router/Customer/CellStatus.vue';
import NimhStatus from '@/router/Customer/NimhStatus.vue';

Vue.use(Router)

//ROUTER CONFIG
export default new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    routes: [
        { path: '/', component: Login },
        { path: '/main_menu/top_page', name: 'top_page', component: TopPage },
        { path: '/main_menu/nimh_status', name: 'nimh_status', component: NimhStatus },
        { path: '/main_menu/bank_status', name: 'bank_status', component: BankStatus,},
        { path: '/main_menu/rack_status', name: 'rack_status', component: RackStatus,},
        { path: '/main_menu/pack_status', name: 'pack_status', component: PackStatus,},
        { path: '/main_menu/cell_status', name: 'cell_status', component: CellStatus,}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js